import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

/**
 * Task 9 — "are you sure" before a suppression is removed.
 *
 * A deliberate dialog rather than window.confirm (which this codebase also uses in places):
 * removing a suppression means the customer starts receiving alerts for that error again, so it
 * is worth stating plainly what will happen.
 */
export default function ConfirmSuppressionRemovalModal({ show, title, message, busy, onConfirm, onClose }) {
    return (
        <Modal isOpen={show} toggle={onClose} backdrop="static" centered>
            <ModalHeader>
                <span style={{ fontSize: 18 }}>{title || "Remove suppression"}</span>
            </ModalHeader>
            <ModalBody>
                <p className="mb-0">{message}</p>
                <p className="text-muted mb-0" style={{ marginTop: 10, fontSize: 13 }}>
                    Already-processed backup sessions are not affected — this only changes how future
                    sessions are reported.
                </p>
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-danger" onClick={onConfirm} disabled={busy}>
                    {busy ? "Removing…" : "Remove"}
                </button>
                <button className="btn btn-secondary" onClick={onClose} disabled={busy}>
                    Cancel
                </button>
            </ModalFooter>
        </Modal>
    );
}
